import React, { useState } from "react";
import "./Reason_cancelling_field_holder.css";
import { Form } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import Pink_Btn from "../../common_btn/pink_btn/Pink_Btn";
import Light_Black_Btn from "../../common_btn/light_black_btn/Light_Black_Btn";
import Success_Modal from "../../common_modal/success_modal/Success_Modal";
import { useDispatch } from "react-redux";
import { cancelOrder, returnOrder } from "../../../../features/order/orderSlice";

import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { encodeId } from "../../../../utils/common";

function Reason_cancelling_field_holder({ setCancelReason,
  cancelReason,
  cancelReasonId,
  selectedItems,
  order,
  setCancelReasonId,
  error,
  cancel_reasons,
  setError, type = "Cancel" }) {
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [message, setMessage] = useState(false);
  const OTHER_REASON_ID = -1;

  const navigate = useNavigate();

  const {
    control,
    reset,
    register,
    setValue, watch,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const handleClick = () => {
    setShowSucsessModal(true);
    setTimeout(() => {
      setShowSucsessModal(false);
      navigate(-1);
    }, 3000);
  };

  const onSubmit = async () => {
    const data = {
      message: cancelReason,
      products: selectedItems,
    };
    let res;
    if (type === "Return") {
      if (cancelReasonId === null) {
        setError("Select Return Reason Required");
        return;
      }
      if (cancelReasonId === -1 && !cancelReason) {
        setError("Enter Return Reason Required");
        return;
      }
      if (selectedItems.length === 0) {
        setError("Please select at least one product to proceed");
        return;
      }

      data.return_reason_id = cancelReasonId;

      if (cancelReasonId === -1) {
        setError("")
        data.return_reason_id = null;
      }
      setError("")
      res = await dispatch(returnOrder({ order_id: order?.id, data: data }));

    }

    if (type === "Cancel") {
      if (cancelReasonId === null) {
        setError("Select Cancel Reason Required");

        return;
      }

      if (cancelReasonId === -1 && !cancelReason) {
        setError("Enter Cancel Reason Required");
        return;
      }
      if (selectedItems.length === 0) {
        setError("Select product to cancel this message");
        return;
      }
      data.cancel_reason_id = cancelReasonId;
      if (cancelReasonId === -1) {
        setError("")
        data.cancel_reason_id = null;
      }

      setError("")
      res = await dispatch(cancelOrder({ order_id: order?.id, data: data }));
    }

    // console.log("data: ", data);
    // console.log("cancelReason: ", cancelReason);
    // console.log("cancelReasonId: ", cancelReasonId);



    if (res.meta?.requestStatus === "fulfilled") {
      handleClick();
      setMessage(res?.payload?.data || "Operation Successfull")

    } else if (res.meta?.requestStatus === "rejected") {
      // Optionally handle error here
    }
  }
  // console.log(cancelReasonId);

  return (
    <>
      <section className="Reason_cancelling_field_holder">
        <Form>


          <Form className="program_form">
            <div className="from-group">
              <Form.Label>Select a reason for {type} Order</Form.Label>
              <Controller
                className="Select_Dropdown_holder"
                name="country_id"
                control={control}
                // rules={{ required: `${type} Rea is required` }}
                render={({ field }) => (
                  <Select
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor: errors.country_id ? "red" : baseStyles,
                      }),
                    }}
                    placeholder={"Select Reason"}
                    {...field}
                    options={cancel_reasons}
                    onChange={(selectedOption) => {
                      setCancelReasonId(selectedOption?.value);
                      setValue("state_id", null);

                    }}
                  />
                )}
              />
            </div>
          </Form>

          {cancelReasonId === -1 &&
            <Form.Group
              className="input_group  mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>
                Could you tell us a reason for  {type}? (optional)
              </Form.Label>
              <Form.Control as="textarea"
                placeholder="Type a reason"
                rows={1}
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)} />
            </Form.Group>
          }
          <p style={{ color: "red" }}>{error}</p>
          <div className="btn_holder">
            <Pink_Btn
              btnText={"Submit"}
              onClick={
                //   () => {
                //   setShowSucsessModal(true);

                //   setTimeout(() => {
                //     setShowSucsessModal(false);
                //     navigate("/profile");
                //   }, 3000);
                // }
                () => onSubmit()
              }
            />
            <Light_Black_Btn
              btnText={"Cancel"}
              onClick={() => {
                navigate(`/order-details/${encodeId(order?.id)}`);
              }}
            />
          </div>
        </Form>
      </section>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText={message}
      />
    </>
  );
}

export default Reason_cancelling_field_holder;
